import firebase from 'firebase/app'
import 'firebase/database'

export default {
  namespaced: true,
  state: {
    tags: []
  },
  getters: {
    tags (state) {
      return state.tags
    }
  },
  mutations: {
    setTags (state, payload) {
      state.tags = payload
    }
  },
  actions: {
    async addTemplateTag ({ dispatch }, tag) {
      await firebase
        .database()
        .ref('template_tags')
        .push(tag)
      return dispatch('getTemplateTags')
    },

    async updateTemplateTag ({ dispatch }, tag) {
      await firebase
        .database()
        .ref('template_tags')
        .child(tag.id)
        .update(tag)
      return dispatch('getTemplateTags')
    },

    async deleteTemplateTag ({ dispatch }, id) {
      await firebase
        .database()
        .ref('template_tags')
        .child(id)
        .remove()
      return dispatch('getTemplateTags')
    },

    async getTemplateTags ({ commit }) {
      const snapshot = await firebase
        .database()
        .ref('template_tags')
        .once('value')

      const tags = snapshot.val()
      commit('setTags', tags)
    }
  }
}
